import React from 'react';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@rocco/components/popover';
import { AVAILABLE_REACTIONS, getEmojiImageUrl } from '../../utils';

/**
 * A reaction picker popover that allows users to react to a message with an
 * emoji. Pass a child component to be the popover trigger.
 */
export function ReactionPicker({
    children,
    open,
    onOpenChange,
    onReact,
}: {
    children: React.ReactNode;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onReact?: (reaction: string) => void;
}) {
    return (
        <Popover
            open={open}
            // Prevent scrolling when the popover is open.
            modal={true}
            onOpenChange={onOpenChange}
        >
            {children && <PopoverTrigger asChild>{children}</PopoverTrigger>}
            <PopoverContent
                className="flex items-center gap-[3px] overflow-hidden rounded-[8px] p-[6px]"
                side="top"
                align="center"
            >
                {AVAILABLE_REACTIONS.map((emoji) => (
                    <button
                        key={emoji}
                        type="button"
                        className="group grid place-items-center p-[2px]"
                        onClick={() => {
                            onOpenChange(false);
                            onReact?.(emoji);
                        }}
                        aria-label={`React with ${emoji}`}
                    >
                        <img
                            // Need to do this trick to scale the image instead
                            // of the button to make the animation smooth on Firefox.
                            className="size-[22px] origin-center transition-transform group-hover:scale-125"
                            src={getEmojiImageUrl(emoji)}
                            alt={emoji}
                        />
                    </button>
                ))}
            </PopoverContent>
        </Popover>
    );
}
